import { render, staticRenderFns } from "./chatIcon.vue?vue&type=template&id=a503617c&"
import script from "./chatIcon.vue?vue&type=script&lang=js&"
export * from "./chatIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports